import React, { useEffect, useState } from 'react';
import { APIROOT } from '../../Helpers/configs';
import { ReplaceValue } from '../../Helpers/requests';

import { getData } from '../../Helpers/requests';

import { FormCategory, FormInfo } from '../shared/FormElements';
import { convertDate } from '../../Helpers/dateHelpers';

import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

//import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';

// import './Customer.css';

export default function SerialInfoCard(props) {
  const [customerData, setCustomerData] = useState('1');
  const [usersData, setUsersData] = useState([]);
  const customerUri = props.serialInfo.store_id;
  const usersUri = 'users';

  const userById = ReplaceValue(usersData, props.serialInfo.installer_id);

  const singleInputRowHeight = 40;

  useEffect(() => {
    getData(`customers/${customerUri}`, {}).then((data) => {
      setCustomerData(data.data.value);
    });
    getData(`${usersUri}`, {
      pagereq: {
        filter: {
          fullfilter: [
            {
              field: 'name',
              search: '',
              strict: false,
            },
          ],
        },
      },
    }).then((data) => {
      setUsersData(data.data.value);
    });
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <FormControl fullWidth>
        <Grid
          container
          rowSpacing={0}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
          style={{
            // background: '#84a1bc91',
            background: 'rgb(235, 237, 248)',
            // borderRadius: 15,
            padding: '5px 10px 5px 5px',
          }}
        >
          <Grid item xs={12} md={12}>
            <Typography variant='h5' sx={{ height: singleInputRowHeight }}>
              Customer Detail
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Card
              sx={{ boxShadow: 'none', border: 'none', background: 'none' }}
            >
              <Box sx={{ width: '100%' }}>
                <Grid
                  container
                  rowSpacing={0}
                  columnSpacing={{ xs: 2 }}
                  rowGap={1}
                >
                  <Grid item xs={12} md={3}>
                    <FormCategory title='Customer:' />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormCategory title='Customer Name:' />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormCategory title='Install Date:' />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormCategory title='Installer:' />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormInfo title={props.serialInfo.store_category_name} />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormInfo title={props.serialInfo.store_name} />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormInfo
                      title={convertDate(props.serialInfo.install_date, 0, 10)}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormInfo title={userById} />
                  </Grid>
                </Grid>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </FormControl>
    </Box>
  );
}
